<template>
  <one-photo-details v-if="is_one_photo == 1" :logo_one="logo_one" :logo_two="logo_two"/>
  <two-photos-details v-else :logo_one="logo_one" :logo_two="logo_two"/>
</template>

<script>
import TwoPhotosDetails from './TwoPhotosDetails'
import onePhotoDetails from "./OnePhotoDetails";
export default {
  props: ['logo_one','logo_two','is_one_photo'],
  components: {
    TwoPhotosDetails,
    onePhotoDetails
  },
}
</script>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/PhotoDetails/PhotoDetails.vue